import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import styled from 'styled-components';

const SocialIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #333;
`;

const SocialText = styled.span`
  font-size: 14px;
  text-transform: uppercase;
  color: #333;
  margin-right: 10px;
`;

const IconList = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const IconItem = styled.li`
  margin: 0 5px;

  a {
    color: #333;
    transition: color 0.3s ease;
    font-size: 1.5rem;
    &:hover {
      color: #4CAF50; /* Green hover effect */
    }
  }
`;

const SocialIcons = () => {
  return (
    <SocialIconsWrapper>
      <SocialText>Follow us on:</SocialText>
      <IconList>
        <IconItem>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
        </IconItem>
       
        <IconItem>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
        </IconItem>
      
      </IconList>
    </SocialIconsWrapper>
  );
};

export default SocialIcons;